import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from '@workspace/ui/components/sonner';
import { type TransferParams, transferApi } from '../../-api/api';

export function useTransfer() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: TransferParams) => transferApi(params),
    onSuccess: (data, variables) => {
      if (data.error) {
        console.error('Error al realizar la transferencia:', data.error);
        toast.error(
          data.error ||
            'Error al realizar la transferencia, por favor intenta de nuevo.',
        );
        return;
      }
      queryClient.invalidateQueries({
        queryKey: ['balance', variables.sourceUrn],
      });
      queryClient.invalidateQueries({
        queryKey: ['transactions', variables.sourceUrn],
      });
      toast.success('Transferencia realizada correctamente');
    },
    onError: (error) => {
      console.error('Error al realizar la transferencia:', error);
      toast.error(
        'Error al realizar la transferencia, por favor intenta de nuevo.',
      );
    },
  });
}
